import React from 'react'
import PropTypes from 'prop-types'

import GoogleMediaFilesPreview from '../../../../GoogleMediaFilesPreview'

import { getLandscapeLogoData } from '../HeadlinesSection/helpers'

const LandscapeLogoSectionPreview = ({ data }) => {
  const { assets } = data
  const landscapeLogoData = getLandscapeLogoData(assets)

  return <GoogleMediaFilesPreview assets={landscapeLogoData} />
}

LandscapeLogoSectionPreview.propTypes = {
  data: PropTypes.object
}

export default LandscapeLogoSectionPreview
